<template>
  <div class="project-bank-tab accordion" role="tablist">
    <AccessBlock :id="PROJECT_BANK_CUSTOMER_BLOCK">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-bank-customer
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-user mr-2"></i>{{ $t('bankSectionCustomer') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse
          id="project-bank-customer"
          role="tabpanel"
          :visible="isOpenAtStart(PROJECT_BANK_CUSTOMER_BLOCK)"
        >
          <div class="accordion-content px-2 py-2">
            <ProjectBankCustomer
              v-if="blockProject('bankCustomer')"
              :blockId="PROJECT_BANK_CUSTOMER_BLOCK"
              :project="blockProject('bankCustomer')"
            />
          </div>
        </b-collapse>
      </div>
    </AccessBlock>
    <AccessBlock :id="PROJECT_BANK_SELF_DISCLOSURE_BLOCK">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-bank-self-disclosure
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-file-text-o mr-2"></i>{{ $t('bankSectionSelfDisclosure') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse
          id="project-bank-self-disclosure"
          role="tabpanel"
          :visible="isOpenAtStart(PROJECT_BANK_SELF_DISCLOSURE_BLOCK)"
        >
          <div class="accordion-content px-2 py-2">
            <ProjectBankSelfDisclosure
              v-if="blockProject('bankSelfDisclosure')"
              :blockId="PROJECT_BANK_SELF_DISCLOSURE_BLOCK"
              :project="blockProject('bankSelfDisclosure')"
            />
          </div>
        </b-collapse>
      </div>
    </AccessBlock>
    <AccessBlock :id="PROJECT_BANK_EMPLOYMENT_INCOME_BLOCK">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-bank-employment-income
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-money mr-2"></i>{{ $t('bankSectionEmploymentIncome') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse
          id="project-bank-employment-income"
          role="tabpanel"
          :visible="isOpenAtStart(PROJECT_BANK_EMPLOYMENT_INCOME_BLOCK)"
        >
          <div class="accordion-content px-2 py-2">
            <ProjectBankEmploymentIncome
              v-if="blockProject('bankEmploymentIncome')"
              :blockId="PROJECT_BANK_EMPLOYMENT_INCOME_BLOCK"
              :project="blockProject('bankEmploymentIncome')"
            />
          </div>
        </b-collapse>
      </div>
    </AccessBlock>
    <AccessBlock :id="PROJECT_BANK_SELF_EMPLOYMENT_BLOCK">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-bank-self-employment
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-briefcase mr-2"></i>{{ $t('bankSectionSelfEmployment') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse
          id="project-bank-self-employment"
          role="tabpanel"
          :visible="isOpenAtStart(PROJECT_BANK_SELF_EMPLOYMENT_BLOCK)"
        >
          <div class="accordion-content px-2 py-2">
            <ProjectBankSelfEmployment
              v-if="blockProject('bankSelfEmployment')"
              :blockId="PROJECT_BANK_SELF_EMPLOYMENT_BLOCK"
              :project="blockProject('bankSelfEmployment')"
            />
          </div>
        </b-collapse>
      </div>
    </AccessBlock>
    <AccessBlock :id="PROJECT_BANK_RENTAL_INCOME_BLOCK">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-bank-rental-income
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-home mr-2"></i>{{ $t('bankSectionRentalIncome') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse
          id="project-bank-rental-income"
          role="tabpanel"
          :visible="isOpenAtStart(PROJECT_BANK_RENTAL_INCOME_BLOCK)"
        >
          <div class="accordion-content px-2 py-2">
            <ProjectBankRentalIncome
              v-if="blockProject('bankRentalIncome')"
              :blockId="PROJECT_BANK_RENTAL_INCOME_BLOCK"
              :project="blockProject('bankRentalIncome')"
            />
          </div>
        </b-collapse>
      </div>
    </AccessBlock>
    <AccessBlock :id="PROJECT_BANK_CAPITAL_ASSETS_BLOCK">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-bank-capital-assets
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-line-chart mr-2"></i>{{ $t('bankSectionCapitalAssets') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse
          id="project-bank-capital-assets"
          role="tabpanel"
          :visible="isOpenAtStart(PROJECT_BANK_CAPITAL_ASSETS_BLOCK)"
        >
          <div class="accordion-content px-2 py-2">
            <ProjectBankCapitalAssets
              v-if="blockProject('bankCapitalAssets')"
              :blockId="PROJECT_BANK_CAPITAL_ASSETS_BLOCK"
              :project="blockProject('bankCapitalAssets')"
            />
          </div>
        </b-collapse>
      </div>
    </AccessBlock>
    <AccessBlock :id="PROJECT_BANK_SUMMARY_BLOCK">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-bank-summary
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-file-archive-o mr-2"></i>{{ $t('bankSectionSummary') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse
          id="project-bank-summary"
          role="tabpanel"
          :visible="isOpenAtStart(PROJECT_BANK_SUMMARY_BLOCK)"
        >
          <div class="accordion-content px-2 py-2">
            <ProjectBankSummary
              v-if="blockProject('bankSummary')"
              :blockId="PROJECT_BANK_SUMMARY_BLOCK"
              :project="blockProject('bankSummary')"
            />
          </div>
        </b-collapse>
      </div>
    </AccessBlock>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AccessBlock from '@/components/Access/AccessBlock.vue';
import ProjectBankCustomer from '@/blocks/project/ProjectBankCustomer';
import ProjectBankSelfDisclosure from '@/blocks/project/ProjectBankSelfDisclosure';
import ProjectBankEmploymentIncome from '@/blocks/project/ProjectBankEmploymentIncome';
import ProjectBankSelfEmployment from '@/blocks/project/ProjectBankSelfEmployment';
import ProjectBankRentalIncome from '@/blocks/project/ProjectBankRentalIncome';
import ProjectBankCapitalAssets from '@/blocks/project/ProjectBankCapitalAssets';
import ProjectBankSummary from '@/blocks/project/ProjectBankSummary';
import {
  PROJECT_BANK_CAPITAL_ASSETS_BLOCK,
  PROJECT_BANK_CUSTOMER_BLOCK,
  PROJECT_BANK_EMPLOYMENT_INCOME_BLOCK,
  PROJECT_BANK_RENTAL_INCOME_BLOCK,
  PROJECT_BANK_SELF_DISCLOSURE_BLOCK,
  PROJECT_BANK_SELF_EMPLOYMENT_BLOCK,
  PROJECT_BANK_SUMMARY_BLOCK,
} from '@/navigation/accessNodes';

/** Number of the unsaved project (ProjectEdit `_new`); it has no blocks yet. */
const NEW_PROJECT_NUMBER = '_new';

/** Blocks of the tab in the order of the sections. */
const BANK_BLOCK_IDS = [
  PROJECT_BANK_CUSTOMER_BLOCK,
  PROJECT_BANK_SELF_DISCLOSURE_BLOCK,
  PROJECT_BANK_EMPLOYMENT_INCOME_BLOCK,
  PROJECT_BANK_SELF_EMPLOYMENT_BLOCK,
  PROJECT_BANK_RENTAL_INCOME_BLOCK,
  PROJECT_BANK_CAPITAL_ASSETS_BLOCK,
  PROJECT_BANK_SUMMARY_BLOCK,
];

/**
 * Tab Bank of the project detail (see feature page projekt-bank): one accordion section per block,
 * the section titles as before. Each section sits inside its `AccessBlock`, so it disappears
 * without a level and its header stays usable for readers. Only the first visible section is open
 * at the start: as before only "Kunde" was open, and a role without "Kunde" does not get an
 * all-collapsed tab.
 */
export default {
  name: 'ProjectBankTab',
  components: {
    AccessBlock,
    ProjectBankCustomer,
    ProjectBankSelfDisclosure,
    ProjectBankEmploymentIncome,
    ProjectBankSelfEmployment,
    ProjectBankRentalIncome,
    ProjectBankCapitalAssets,
    ProjectBankSummary,
  },
  props: {
    project: { type: Object, required: true },
  },
  data() {
    return {
      PROJECT_BANK_CUSTOMER_BLOCK,
      PROJECT_BANK_SELF_DISCLOSURE_BLOCK,
      PROJECT_BANK_EMPLOYMENT_INCOME_BLOCK,
      PROJECT_BANK_SELF_EMPLOYMENT_BLOCK,
      PROJECT_BANK_RENTAL_INCOME_BLOCK,
      PROJECT_BANK_CAPITAL_ASSETS_BLOCK,
      PROJECT_BANK_SUMMARY_BLOCK,
    };
  },
  computed: {
    ...mapGetters(['getAccessLevel']),
    firstVisibleBlockId() {
      return BANK_BLOCK_IDS.find((blockId) => this.getAccessLevel(blockId) !== null) ?? null;
    },
  },
  methods: {
    isOpenAtStart(blockId) {
      return blockId === this.firstVisibleBlockId;
    },
    /** Block data of the block field; the unsaved project goes to the block itself. */
    blockProject(blockField) {
      if (this.project.number === NEW_PROJECT_NUMBER) {
        return this.project;
      }

      return this.project.blocks?.[blockField] ?? null;
    },
  },
};
</script>
